module.exports = __webpack_public_path__ + "img/1716360025823-WhatsApp Image 2024-05-22 at 14.28.47.jpeg.c541570c.webp";